import countries from "./countries.json";
import Picker from "./Picker";

type Country = { label: string; value: string; name: string };

type Props = {
  onCountryChange: (country: Country | null) => void;
};

export default function CountryPicker({ onCountryChange }: Props) {
  return (
    <Picker
      options={options}
      selectOption={(option) => onCountryChange(findCountry(option.value))}
    />
  );
}

const options = countries.map((c) => {
  const value = c.country_code;
  const label = `${c.flag} +${c.country_code}`;
  const name = c.name;
  return { value, label, name } as Country;
});

function findCountry(countryCode: string) {
  return options.find((c) => c.value === countryCode) || null;
}
